// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3GQ1h","col":"Table_col__3buWP","fulfillmentStatus":"Table_fulfillmentStatus__AVcav","emailCol":"Table_emailCol__33zy4"};